import { retryErrorSrc176Evid103 } from '@wix/error-handler-core/@wix/bi-logger-os-data/v2';
import { withoutDefaults } from '../util/withoutDefaults';
export function reportErrorRetryBi(errorHandler, params) {
  const {
    biLogger
  } = errorHandler;
  const {
    errorAccessor
  } = params;
  const {
    errorHandlerState
  } = errorAccessor;
  const sessionId = errorHandlerState == null ? void 0 : errorHandlerState.sessionId;
  if (!sessionId) {
    return;
  }
  biLogger.report(withoutDefaults(retryErrorSrc176Evid103)({
    session_id: sessionId
  }));
}
//# sourceMappingURL=reportErrorRetryBi.js.map